import { render, staticRenderFns } from "./reisen-metadata-card-inlandsfluege.vue?vue&type=template&id=da3d54d2&scoped=true"
import script from "./reisen-metadata-card-inlandsfluege.vue?vue&type=script&lang=js"
export * from "./reisen-metadata-card-inlandsfluege.vue?vue&type=script&lang=js"
import style0 from "./reisen-metadata-card-inlandsfluege.vue?vue&type=style&index=0&id=da3d54d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3d54d2",
  null
  
)

export default component.exports